<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('VolumeProfileTool', function() {
            return {
                group: 'VolumeProfile', category: 'Volume', icon: 'volume_profile.svg',
                name: 'Fixed Range Volume Profile (OHLCV estimate)',
                type: 'Price',
                hint: 'Estimated volume by price from visible OHLCV candles',
                data: [],
                settings: {},
            }
        }, 'Fixed Range Volume Profile')
</script>
